module.exports = __webpack_public_path__ + "static/media/shutterstock-46688014.ec07dfaa.webp";